import VanillaTilt from 'vanilla-tilt'
import hamburgersInit from '../hamburgers/hamburgers'
import smoothScrollInit from '../smooth-scroll/smooth-scroll'

const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

/**
 * Init smooth scroll on anchor links click
 */
smoothScrollInit({
    offsetTopDelta: 0,
    scrollSpeedTime: 1500,
})

/**
 * Init mobile menu func
 */
hamburgersInit({
    hamburgerClassSelector: '.hamburger',
    headerMenuClassSelector: '.header__menu-container',
    headerMenuLinksClassSelector: '.header__menu-container a',
})

/**
 * Parallax for home intro
 */
const parallaxDataPropsGeneral = {
    reset: false,
    max: 5,
    perspective: 2000,
    speed: 10000,
    'mouse-event-element': '.section._top._home'
}
const parallaxData = [
    {
        selector: '.section__parallax-main',
        props: {
            ...parallaxDataPropsGeneral,
        },
    },
    {
        selector: '.section__parallax-logo',
        props: {
            ...parallaxDataPropsGeneral,
        },
    },
]

if (!isSafari) {
    parallaxData.forEach(elData => {
        const el = document.querySelector(elData.selector)

        if (el === null) {
            return
        }

        VanillaTilt.init(
            el,
            elData.props
        )
    })

    jQuery(document).ready(function ($) {
        const $logoParallaxBg = $('.section__parallax-logo-bg')

        parallaxMoveBg($logoParallaxBg)

        $('.section._top._home').mousemove(function (event) {
            parallaxMoveBg($logoParallaxBg, event)
        })
    })
}

function parallaxMoveBg($logoParallaxBg, event) {
    const clientX = event ? event.clientX : 0
    const clientY = event ? event.clientY : 0

    $logoParallaxBg.css({
        backgroundPosition: ((window.innerWidth / 2 - clientX) / 100 -100) + 'px ' + ((window.innerHeight / 2 - clientY) / 100 -150) + 'px'
    })
}